// extracted by mini-css-extract-plugin
export var anchor = "forms-module--anchor--ac567";
export var buttonContainer = "forms-module--buttonContainer--4c1c7";
export var deliveryMethod = "forms-module--deliveryMethod--7a379";
export var desktopOnlyMod = "forms-module--desktopOnlyMod--1b4a6";
export var divDeliveryInfo = "forms-module--divDeliveryInfo--bf801";
export var dropdownHeader = "forms-module--dropdownHeader--27529";
export var dropdownItemIndent = "forms-module--dropdownItemIndent--1f03a";
export var form = "forms-module--form--604cc";
export var formActionButtons = "forms-module--formActionButtons--2e85a";
export var formShortened = "forms-module--formShortened--cf4ee";
export var header = "forms-module--header--814f8";
export var icon = "forms-module--icon--db154";
export var iconbutton = "forms-module--iconbutton--629d5";
export var iframeQR = "forms-module--iframeQR--83508";
export var imagebutton = "forms-module--imagebutton--d581c";
export var italic = "forms-module--italic--5a6db";
export var leftAlign = "forms-module--leftAlign--2293f";
export var linkButton = "forms-module--linkButton--b08bb";
export var mainButton = "forms-module--mainButton--15c37";
export var mobileOnlyMod = "forms-module--mobileOnlyMod--2699a";
export var msg = "forms-module--msg--6a834";
export var orderSelectionContainer = "forms-module--orderSelectionContainer--c6e44";
export var pickUpLink = "forms-module--pickUpLink--cb50e";
export var readOnlyInput = "forms-module--readOnlyInput--c856a";
export var secondaryButton = "forms-module--secondaryButton--32990";
export var text = "forms-module--text--237fb";
export var textButton = "forms-module--textButton--21d9b";
export var textbutton = "forms-module--textbutton--7c94a";
export var transparentButton = "forms-module--transparentButton--c945d";
export var voucherDetails = "forms-module--voucherDetails--0d904";
export var voucherInputContainer = "forms-module--voucherInputContainer--19917";